<template>
    <div>
        <h1>{{t('Team')}}</h1>
        <div v-if="!team_pending && !team_error">
            <BRow>
                <BCol cols="12" md="9" lg="9">
                    <BRow>
                        <BCol v-for="member in team" :key="member.id" cols="6" md="6" lg="3" class="mb-4 team-member">
                            <BImg :src="member.image.thumbs.small.url ? member.image.thumbs.small.is_available==true ? member.image.thumbs.small.url : member.image.original : member.image.original" fluid class="mb-2 photo-img" />
                            <div class="name">{{ member.name }}</div>
                            <div class="position">{{ member.position }}</div>
                            <div class="phone" v-if="member.phone">
                                <a :href="`tel:${member.phone}`">{{ member.phone }}</a>
                            </div>
                            <div class="email" v-if="member.email">
                                <a :href="`mailto:${member.email}`">{{ member.email }}</a>
                            </div>
                        </BCol>
                    </BRow>
                </BCol>
                <BCol cols="12" md="3" lg="3">
                    <RoundedPanel>
                        <div class="text-center">
                            <h2>{{ t('Working with us')}}</h2>
                            <p>{{ t('If you want to participate in the fair, you can fill out a')}} <NuxtLink :to="localePath('/about/workwithus')">{{ t('volunteer application')}}</NuxtLink></p>
                        </div>
                    </RoundedPanel>
                </BCol>
            </BRow>

        </div>
    </div>
</template>

<script setup lang="ts">
import RoundedPanel from '~/components/global/RoundedPanel.vue'
const { $apiFetch } = useNuxtApp()
const { t, locale } = useI18n()
const localePath = useLocalePath()

const { data: team, pending: team_pending, error: team_error } = await useAsyncData('team', async () => {
    return await $apiFetch(`/${locale.value}/api/site/about/team/`)
})

definePageMeta({
    auth: 'guest',
    layout: 'about-layout',
})

useHead({
    title: t('Team'),
})

</script>

<style scoped>
.team-member {
    .name {
        font-size: 1.25rem;
        font-weight: 600;
    }
    .position {
        font-size: 1rem;
    }
    .phone, .email {
        font-size: 0.875rem;
        color: var(--bs-gray-600);
    }
    .photo-img {
        display: block;
        width: 100%;
        aspect-ratio: 3 / 4;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
        /* Default images are grayscale; color on hover/tap */
        filter: grayscale(100%);
        transition: filter 0.3s ease-in-out;
    }
    &:hover .photo-img,
    &:focus-within .photo-img {
        filter: none;
    }
    @media (hover: none) {
        .photo-img:active {
            filter: none;
        }
    }
}
</style>

<i18n lang="json">
    {
        "ru": {
            "Team": "Команда",
            "Working with us": "Работа с нами",
            "If you want to participate in the fair, you can fill out a": "Если вы хотите принять участие в ярмарке, вы можете заполнить",
            "volunteer application": "анкету волонтера"
        }
    }
</i18n>